"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_1 = require("react");
const react_custom_scrollbars_1 = require("react-custom-scrollbars");
class Scrollbars extends react_1.Component {
    constructor(props) {
        super(props);
        this.state = {
            height: props.offsetHeight,
        };
    }
    render() {
        const { children } = this.props;
        const { height } = this.state;
        return (React.createElement(react_custom_scrollbars_1.Scrollbars, { universal: true, ref: (instance) => this.scrollbars = instance, style: {
                height: `calc(100vh - ${height})`,
            } }, children));
    }
    scrollToTop() {
        this.scrollbars.scrollToTop();
    }
}
Scrollbars.defaultProps = {
    offsetHeight: '0',
};
exports.Scrollbars = Scrollbars;



//////////////////
// WEBPACK FOOTER
// ./src/components/Scrollbars.tsx
// module id = 367
// module chunks = 0